// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__1u-sB","btnPrimary":"SearchBar_btnPrimary__3GIKy"};